import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { simplifyUrl } from '@/lib/url'
import { unwrappedMembershipsByPubkeyAtom } from '@/atoms/memberships'
import RelayIcon from './RelayIcon'

export default function RelayMemberIconBadges({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const memberships = useAtomValue(unwrappedMembershipsByPubkeyAtom)
  if (!memberships) return null
  const inner = memberships.get(pubkey)

  if (!inner || inner.size === 0) return null

  const urls = [...inner.keys()]

  return (
    <>
      {urls.map((url) => (
        <div
          key={url}
          className="rounded-full bg-muted p-0.5 flex items-center"
          title={t('Member of {{relay}}', { relay: simplifyUrl(url) })}
        >
          <RelayIcon url={url} className="w-3 h-3" iconSize={8} />
        </div>
      ))}
    </>
  )
}
